import { Button, Grid, TextField } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {addCantidadMensualidadesAction} from "./../../../../../ducks/cambioPaqueteDuck"
import { ToastMessage } from "./../../../../../global/ToastMessage"
const FieldMensualidades = () => {
    const { cantidadMensualidad, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const { cliente } = useSelector(store => store.cambios)
    const noMensualidad = cliente.paquete?.Numero_Pagos ?? 0
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(addCantidadMensualidadesAction({cantidadMensualidad: noMensualidad }))
    },[dispatch, noMensualidad])
    const handleGuardar = () => {
        hangdleClickEditar()
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const hangdleClickCancelar = () => {
        setEditar(!editar)
    }
    const handleChange = (event) => {
        const newMensualidad = event.target.value

        if (Number(newMensualidad) <= 0) {
            ToastMessage.fire({
                icon: "info",
                title: "La cantidad de mensualidades debe ser mayor o igaul a 1",
            })
            return null
        }
        dispatch(addCantidadMensualidadesAction({cantidadMensualidad: newMensualidad }))
    }
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <TextField
                            disabled={!editar || clavePaquete === "0"}
                            value={cantidadMensualidad}
                            style={{ width: "100%" }}
                            id={`outlined-number-conter-mensualidades`}
                            label="No. Mensualidades"
                            name="mensualidades"
                            onChange={handleChange}
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                                disabled={clavePaquete === "0"}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={cantidadMensualidad === 0}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickCancelar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default FieldMensualidades